import React from 'react';
import {Control, UseFormRegister} from 'react-hook-form';
import {t} from '@lingui/core/macro';

import {maxChatAPI} from 'entities/notification';
import MaxChat from 'shared/ui/icons/MaxChat';
import IHttpMonitorOutput from 'features/http/model/HttpMonitor/IHttpMonitor';

import NotifyChannelBlock from '../NotifyChannelBlock/NotifyChannelBlock';

interface INotifyMaxProps {
    item?: IHttpMonitorOutput,
    control: Control<any>,
    register: UseFormRegister<any>,
}

const NotifyMax: React.FC<INotifyMaxProps> = ({item, control, register}) => {
    const {data, isLoading} = maxChatAPI.useGetActiveQuery();

    return (
        <NotifyChannelBlock
            items={data}
            isLoading={isLoading}
            getLabel={(chat) => chat.description ?? chat.chat}
            control={control}
            register={register}
            fieldName="max_chats"
            settingsField="notify_max_chats_settings"
            settings={item?.notify_max_chats_settings ?? []}
            icon={<MaxChat color="colored"/>}
            connectIcon={<MaxChat color="gray"/>}
            title="Max"
            notConnectedText={t`Уведомления через Max не подключены`}
            // eslint-disable-next-line max-len
            hint={t`Для отправки уведомлений о сбоях нужно подключить Max. После подключения вы сможете выбрать его в настройках монитора.`}
            bordered
        />
    );
};

export default NotifyMax;
